export const LEGAL_LOADING = "LEGAL_LOADING";
export const LEGAL_RESET = "LEGAL_RESET";
export const GET_LEGAL = "GET_LEGAL";
export const GET_LEGAL_SUCCESS = "GET_LEGAL_SUCCESS";
export const GET_LEGAL_FAIL = "GET_LEGAL_FAIL";
export const DELETE_LEGAL = "DELETE_LEGAL"
export const DELETE_LEGAL_SUCCESS = "DELETE_LEGAL_SUCCESS"
export const DELETE_LEGAL_FAIL = "DELETE_LEGAL_FAIL"
export const UPDATE_LEGAL = "UPDATE_LEGAL"
export const UPDATE_LEGAL_SUCCESS = "UPDATE_LEGAL_SUCCESS"
export const UPDATE_LEGAL_FAIL = "UPDATE_LEGAL_FAIL"
export const ADD_NEW_LEGAL = "ADD_NEW_LEGAL"
export const ADD_LEGAL_SUCCESS = "ADD_LEGAL_SUCCESS"
export const ADD_LEGAL_FAIL = "ADD_LEGAL_FAIL"